import { SPRITES } from './assetManifest';

let initialized = false;

export async function initialize() {
  if (initialized) return;

  // Validate all sprite definitions
  Object.entries(SPRITES).forEach(([spriteId, sprite]) => {
    if (!sprite.srcs) {
      throw new Error(`Sprite ${spriteId} missing srcs property`);
    }

    if (sprite.variations) {
      // Validate all variations have valid URLs
      sprite.variations.forEach(variation => {
        const url = sprite.srcs.replace('{variation}', variation);
        if (!url.startsWith('assets/')) {
          throw new Error(`Invalid sprite URL format: ${url}`);
        }
      });
    } else {
      // Validate single sprite URL
      if (!sprite.srcs.startsWith('assets/')) {
        throw new Error(`Invalid sprite URL format: ${sprite.srcs}`);
      }
    }
  });

  initialized = true;
}

export function getSpriteUrl(spriteId, variation = null) {
  const sprite = SPRITES[spriteId];
  if (!sprite) {
    throw new Error(`Sprite ${spriteId} not found`);
  }

  // Check if the sprite URL contains a variation placeholder
  const requiresVariation = sprite.srcs.includes('{variation}');

  if (requiresVariation && !variation) {
    throw new Error(`Sprite ${spriteId} requires a variation but none was provided. Valid variations are: ${sprite.variations.join(', ')}`);
  }

  if (variation) {
    // Check if sprite supports variations
    if (!sprite.variations) {
      throw new Error(`Sprite ${spriteId} does not support variations`);
    }

    // Validate the variation exists
    if (!sprite.variations.includes(variation)) {
      throw new Error(`Invalid variation ${variation} for sprite ${spriteId}. Valid variations are: ${sprite.variations.join(', ')}`);
    }

    // Replace the {variation} placeholder in the URL
    return sprite.srcs.replace('{variation}', variation);
  }

  // Return the direct URL if no variation is needed
  return sprite.srcs;
}
